var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"container"},[_c('span',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.required ? '* ' : '')+" "),_vm._t("default")],2),_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.value},on:{"change":_vm.localChecked}}),_c('span',{staticClass:"checkmark"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }